export const routerSplitCharacter = '#$%@'



// WEBPACK FOOTER //
// ./src/utils/Constant.js